import AboutJussi from './AboutJussi';

export default AboutJussi;
